// Editorial categories. `pathSlug` is the URL fragment per language:
//   /banque-argent/...  /en/banking-money/...  /es/banca-dinero/...
// `slug` is the canonical English-style key used internally (e.g. for
// frontmatter `category` values and lookups).
export const categories = [
  {
    slug: 'visa-residence',
    featured: true,
    pathSlug: { fr: 'visa-residence', en: 'visa-residency', es: 'visa-residencia' },
    label: { fr: 'Visas & résidence', en: 'Visas & residency', es: 'Visas y residencia' },
    description: {
      fr: 'Les programmes de résidence panaméens, démystifiés.',
      en: 'Panama residency programs, demystified.',
      es: 'Programas de residencia panameños, desmitificados.',
    },
  },
  {
    slug: 'banque-argent',
    featured: true,
    pathSlug: { fr: 'banque-argent', en: 'banking-money', es: 'banca-dinero' },
    label: { fr: 'Finances', en: 'Finance', es: 'Finanzas' },
    description: {
      fr: 'Banques, transferts, fiscalité, investissement.',
      en: 'Banks, transfers, taxation, investing.',
      es: 'Bancos, transferencias, fiscalidad, inversión.',
    },
  },
  {
    slug: 'assurance',
    featured: true,
    pathSlug: { fr: 'assurance', en: 'insurance', es: 'seguro' },
    label: { fr: 'Assurances', en: 'Insurance', es: 'Seguros' },
    description: {
      fr: 'Santé, voyage, expat — comparatifs et conseils.',
      en: 'Health, travel, expat — comparisons and tips.',
      es: 'Salud, viaje, expat — comparativas y consejos.',
    },
  },
  {
    slug: 'animaux-chiens',
    featured: true,
    pathSlug: { fr: 'animaux-chiens', en: 'pets-dogs', es: 'mascotas-perros' },
    label: { fr: 'Animaux', en: 'Pets', es: 'Mascotas' },
    description: {
      fr: 'Faire venir son chien au Panama, étape par étape.',
      en: 'Bringing your dog to Panama, step by step.',
      es: 'Traer a tu perro a Panamá, paso a paso.',
    },
  },
  {
    slug: 'vols',
    featured: true,
    pathSlug: { fr: 'vols', en: 'flights', es: 'vuelos' },
    label: { fr: 'Vols', en: 'Flights', es: 'Vuelos' },
    description: {
      fr: 'Tarifs, routes et compagnies vers Panama.',
      en: 'Fares, routes and carriers to Panama.',
      es: 'Tarifas, rutas y aerolíneas a Panamá.',
    },
  },
  {
    slug: 'espagnol',
    featured: true,
    pathSlug: { fr: 'espagnol', en: 'spanish', es: 'espanol' },
    label: { fr: 'Espagnol', en: 'Spanish', es: 'Español' },
    description: {
      fr: 'Apprendre l\'espagnol panaméen, niveau par niveau.',
      en: 'Learn Panamanian Spanish, level by level.',
      es: 'Aprender el español panameño, nivel a nivel.',
    },
  },
  {
    slug: 'vie-quotidienne',
    featured: false,
    pathSlug: { fr: 'vie-quotidienne', en: 'daily-life', es: 'vida-cotidiana' },
    label: { fr: 'Vie quotidienne', en: 'Daily life', es: 'Vida cotidiana' },
    description: {
      fr: 'Coût de la vie, services, démarches.',
      en: 'Cost of living, services, paperwork.',
      es: 'Costo de vida, servicios, trámites.',
    },
  },
  {
    slug: 'immobilier',
    featured: false,
    pathSlug: { fr: 'immobilier', en: 'real-estate', es: 'inmuebles' },
    label: { fr: 'Immobilier', en: 'Real estate', es: 'Inmuebles' },
    description: {
      fr: 'Acheter, louer, investir — quartiers et marchés.',
      en: 'Buy, rent, invest — neighborhoods and markets.',
      es: 'Comprar, alquilar, invertir — barrios y mercados.',
    },
  },
  {
    slug: 'securite',
    featured: false,
    pathSlug: { fr: 'securite', en: 'security', es: 'seguridad' },
    label: { fr: 'Sécurité', en: 'Security', es: 'Seguridad' },
    description: {
      fr: 'Cybersécurité, gestionnaires de mots de passe, VPN, protection des données expat.',
      en: 'Cybersecurity, password managers, VPN, expat data protection.',
      es: 'Ciberseguridad, gestores de contraseñas, VPN, protección de datos expat.',
    },
  },
  {
    slug: 'compliance',
    featured: true,
    pathSlug: { fr: 'compliance', en: 'compliance', es: 'compliance' },
    label: { fr: 'Compliance', en: 'Compliance', es: 'Compliance' },
    description: {
      fr: 'Conformité fiscale et juridique pour expats et sociétés panaméennes.',
      en: 'Tax and legal compliance for expats and Panamanian companies.',
      es: 'Conformidad fiscal y legal para expats y sociedades panameñas.',
    },
  },
  {
    slug: 'investissement',
    featured: false,
    pathSlug: { fr: 'investissement', en: 'investment', es: 'inversion' },
    label: { fr: 'Investissement', en: 'Investment', es: 'Inversión' },
    description: {
      fr: 'Trading, immobilier rentable, fonds, structuration patrimoniale au Panama.',
      en: 'Trading, rental real estate, funds, asset structuring in Panama.',
      es: 'Trading, inmuebles rentables, fondos, estructuración patrimonial en Panamá.',
    },
  },
];

export const getCategoryBySlug = (slug) => categories.find((c) => c.slug === slug);
export const getCategoryByPathSlug = (lang, pathSlug) =>
  categories.find((c) => c.pathSlug[lang] === pathSlug);
export const getFeaturedCategories = () => categories.filter((c) => c.featured);
